var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacao", $$v);
      },
      expression: "form.filters.formacao"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data de Realização",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataRealizacao", $$v);
      },
      expression: "form.filters.dataRealizacao"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": _vm.statusSolicitacao,
      "item-text": 'descricao',
      "item-value": 'descricao',
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.status,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "status", $$v);
      },
      expression: "form.filters.status"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarAtas();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listAtas,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.formacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.formacao) + " ")];
      }
    }, {
      key: `item.dataRealizacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataRealizacao)) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.status) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": _vm.isStatusConcluida(item) ? 'Baixar Ata' : 'Enviar Ata',
            "icon": _vm.isStatusConcluida(item) ? 'mdi-arrow-down' : 'mdi-arrow-up',
            "small": true
          },
          on: {
            "click": function ($event) {
              _vm.isStatusConcluida(item) ? _vm.baixarAta(item) : _vm.openDialogEnviarAta(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('EnviarAtaDialog', {
    attrs: {
      "visible": _vm.dialogEnviarAta.visible,
      "content": _vm.dialogEnviarAta.content,
      "edit": _vm.dialogEnviarAta.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogEnviarAta.close();
      },
      "onSave": function ($event) {
        return _vm.buscarAtas();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }